import React, { useState, useRef, useEffect } from 'react';
import Icon from 'components/commons/icon/Icon';
import LoginSideMenu from './components/LoginSideMenu';
import SideMenu from 'components/features/side-menu/SideMenu';
import * as api from 'config/api';
import { useRouting } from 'hooks/useRouting';
import { getLastDT } from 'components/commons/Header';
import { HeadBlock } from './components/HeadBlock';

const PremiumLp: React.FC = () => {
  const authenticatedRef = useRef<boolean>(sessionStorage.user !== undefined);
  const authenticated = authenticatedRef.current;
  const [accountExpandable, accountToggleExpandable] = useState<boolean>(false);
  const [reportExpandable, reportToggleExpandable] = useState<boolean>(false);
  const [advisorExpandable, advisorToggleExpandable] = useState<boolean>(false);
  const [magazineExpandable, magazineToggleExpandable] = useState<boolean>(
    false
  );

  useEffect(() => {
    initializeScrolTop();
  }, []);

  const initializeScrolTop = (): void => {
    document.getElementsByTagName('html')[0].scrollTop = 0;
    document.getElementsByTagName('body')[0].scrollTop = 0;
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const onClickContent = (event: any) => {
    switch (event.currentTarget.id) {
      case 'account':
        return accountToggleExpandable(!accountExpandable);
      case 'report':
        return reportToggleExpandable(!reportExpandable);
      case 'advisor':
        return advisorToggleExpandable(!advisorExpandable);
      case 'magazine':
        return magazineToggleExpandable(!magazineExpandable);
    }
  };

  const onClickSideMenu = (): void => {
    if (authenticated) {
      !showSideMenu ? menuShow() : menuHideAnimate();
    } else {
      !showSideMenuLp ? menuShowLp() : menuHideAnimateLp();
    }
  };

  const [showSideMenuLp, setShowSideMenuLp] = useState<boolean>(false);
  const [hideAnimateLp, setHideAnimateLp] = useState<boolean>(false);

  const menuShowLp = (): void => {
    setShowSideMenuLp(true);
    setHideAnimateLp(false);
  };
  const menuHideLp = (): void => {
    setShowSideMenuLp(false);
  };
  const menuHideAnimateLp = (): void => {
    setHideAnimateLp(true);
  };

  const routing = useRouting();
  const [showSideMenu, setShowSideMenu] = useState<boolean>(false);
  const [hideAnimate, setHideAnimate] = useState<boolean>(false);

  const menuShow = (): void => {
    setShowSideMenu(true);
    setHideAnimate(false);
  };
  const menuHide = (): void => {
    setShowSideMenu(false);
  };
  const menuHideAnimate = (): void => {
    setHideAnimate(true);
  };
  const goBack = (): void => {
    routing.backRouting(true);
  };
  const goSecurityaccounts = (): void => {
    if (showSideMenu) {
      menuHideAnimate();
    }
    routing.pushRouting({ path: `/securityaccounts` }, true);
  };

  const clsPing = 'rounded-full h-2 w-2 bg-tradewell';
  const [showPing, setShowPing] = useState<boolean>(false);
  useEffect(() => {
    api.getNotifications().then(ret => {
      if (ret && ret.Items.length > 0) {
        // お知らせ一覧の最新の更新日時を取得
        const dtLatest = getLastDT(ret.Items[0].InsTime, ret.Items[0].UpdTime);

        const setting = localStorage.getItem('bell_state');
        if (setting === null) {
          setShowPing(true);
        } else {
          const dtStorage = new Date(JSON.parse(setting).LastDateTime);
          if (dtLatest.getTime() > dtStorage.getTime()) {
            setShowPing(true);
          }
        }
      }
    });
  }, []);

  return (
    <>
      <HeadBlock />
      <div className="premium-lp">
        <header
          className="bg-gray-100  border-b-2 border-gray-300 sticky top-0 z-30"
          id="id_header">
          <nav className="flex p-2">
            <div className="flex-1 flex justify-start">
              <button className="flex items-center p-2" onClick={goBack}>
                <Icon name="chevron-left" className="text-2xl text-gray-700" />
                <div className="label">戻る</div>
              </button>
            </div>
            <h1 className="font-bold text-center p-2">プレミアム</h1>
            <div className="flex-1 flex justify-end">
              {authenticated && (
                <div
                  className={`flex items-center cursor-pointer`}
                  onClick={() => goSecurityaccounts()}>
                  <img
                    src="./static/images/securitiesButton.svg"
                    width="50"
                    height="30"
                    alt="口座一覧へ"
                  />
                </div>
              )}
              <div className="flex items-center">
                <section className="pl-4 pr-2 pt-2">
                  <div
                    className={
                      showSideMenuLp || showSideMenu
                        ? 'btn-trigger active'
                        : 'btn-trigger'
                    }
                    id="btn01"
                    onClick={onClickSideMenu}>
                    <span />
                    <span />
                    <span />
                  </div>
                </section>
                <span
                  className={`${clsPing} -mt-6 -ml-3 z-10 ${
                    showSideMenu ? 'hidden' : ''
                  } ${showPing ? '' : 'hidden'}`}
                />
              </div>
            </div>
          </nav>
        </header>
        {/* LPサイドメニュー */}
        {showSideMenuLp && (
          <LoginSideMenu
            hideAnimate={hideAnimateLp}
            menuHide={menuHideLp}
            onNavLinkClick={(e: React.MouseEvent, path: string) => {
              return;
            }}
          />
        )}
        {/* アセプラサイドメニュー */}
        {showSideMenu && (
          <div className={`fixed left-0 ui-h-screen w-screen z-20`}>
            <SideMenu
              hideAnimate={hideAnimate}
              menuHide={menuHide}
              onNavLinkClick={(e: React.MouseEvent, path: string) => {
                return;
              }}
              showPing={{ shown: showPing }}
            />
          </div>
        )}
        <div className="main-visual-block">
          <div className="main-visual">
            <div className="main-visual-title-primary">みんかぶプレミアム</div>
            <div className="main-visual-title-secondary">
              初回登録30日間無料
            </div>
          </div>
          <div className="main-visual-note-primary">
            アプリからはみんかぶプレミアムのお申し込みはできません。
            <br />
            「みんかぶプレミアム」の公式ウェブサイトをご利用下さい。
          </div>
        </div>
        <div className="lp-section-block">
          <ul className="plan-list-btn-row">
            <li className="plan-list-btn-item">
              <div className="plan-list-btn-item-block">
                <div className="plan-list-btn-label">ご利用中のプラン</div>
                <div className="btn btn-round-outline btn-round-secondary">
                  無料会員
                </div>
              </div>
            </li>
            <li className="plan-list-btn-item">
              <div className="plan-list-btn-item-block">
                <div className="btn btn-round-outline btn-round-primary">
                  プレミアム会員
                </div>
              </div>
            </li>
          </ul>
        </div>
        {/*口座連携*/}
        <div className="lp-section-block">
          <div className="panel-plan-info">
            <div className="plan-header">
              <div className="plan-badge">口座連携</div>
              <ul className="plan-header-list">
                <li className="plan-header-list-item status-free">
                  <div className="plan-header-list-title">SBI証券のみ</div>
                </li>
                <li className="plan-header-list-item status-premium">
                  <div className="plan-header-list-title">制限なし</div>
                </li>
              </ul>
            </div>
            <div className="plan-body">
              <div
                className={
                  accountExpandable
                    ? 'plan-body-contents is-expanded ui-effect-fade-in-300 visible'
                    : 'plan-body-contents is-expanded ui-effect-fade-out-300 invisible'
                }
                style={{
                  maxHeight: accountExpandable ? '' : '0px',
                  display: accountExpandable ? '' : 'none',
                }}>
                <div className="plan-body-visual">
                  <img
                    src="/static/images/premiumLP/walk2.png"
                    alt=""
                    className="plan-body-visual-primary"
                  />
                  <img
                    src="/static/images/lp/home_shisan.png"
                    alt=""
                    className="plan-body-visual-secondary"
                  />
                </div>
                <div className="plan-body-block">
                  <div className="plan-body-title">一目でわかる資産状況</div>
                  <div className="plan-body-note">
                    複数の証券口座の資産をまとめて一つのチャートで確認できます。資産推移、損益推移など多様なチャートをご用意しています。
                  </div>
                </div>
              </div>
              <div
                className="plan-toggle-row cursor-pointer"
                id="account"
                onClick={onClickContent}>
                <div className="plan-toggle-label">
                  {accountExpandable ? '閉じる' : 'どんな機能？'}
                </div>
                <Icon
                  className="text-2xl transition duration-300"
                  name={
                    accountExpandable
                      ? 'chevron-down transform rotate-180'
                      : 'chevron-down transform rotate-0'
                  }
                />
              </div>
            </div>
          </div>
        </div>
        {/*資産レポート*/}
        <div className="lp-section-block">
          <div className="panel-plan-info">
            <div className="plan-header">
              <div className="plan-badge">資産レポート</div>
              <ul className="plan-header-list">
                <li className="plan-header-list-item status-free">
                  <ul className="plan-header-note-list">
                    <li className="plan-header-note-list-item">
                      ・毎日の資産変動
                    </li>
                  </ul>
                </li>
                <li className="plan-header-list-item status-premium">
                  <ul className="plan-header-note-list">
                    <li className="plan-header-note-list-item">
                      ・毎日の資産変動
                    </li>
                    <li className="plan-header-note-list-item">
                      ・1週間の振り返り
                    </li>
                    <li className="plan-header-note-list-item">
                      ・1ヶ月の振り返りと提案
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
            <div className="plan-body">
              <div
                className={
                  reportExpandable
                    ? 'plan-body-contents is-expanded ui-effect-fade-in-300 visible'
                    : 'plan-body-contents is-expanded ui-effect-fade-out-300 invisible'
                }
                style={{
                  maxHeight: reportExpandable ? '' : '0px',
                  display: reportExpandable ? '' : 'none',
                }}>
                <div className="plan-body-visual">
                  <img
                    src="/static/images/premiumLP/walk3.png"
                    alt=""
                    className="plan-body-visual-primary"
                  />
                  <img
                    src="/static/images/lp/report.png"
                    alt=""
                    className="plan-body-visual-secondary"
                  />
                </div>
                <div className="plan-body-block">
                  <div className="plan-body-title">
                    資産状況をいち早くお知らせ
                  </div>
                  <div className="plan-body-note">
                    保有銘柄に影響がありそうな情報や価格の変動を通知します。また、運用の分析に役立つ定期レポートも届きます。
                  </div>
                </div>
              </div>
              <div
                className="plan-toggle-row cursor-pointer"
                id="report"
                onClick={onClickContent}>
                <div className="plan-toggle-label">
                  {reportExpandable ? '閉じる' : 'どんな機能？'}
                </div>
                <Icon
                  className="text-2xl transition duration-300"
                  name={
                    reportExpandable
                      ? 'chevron-down transform rotate-180'
                      : 'chevron-down transform rotate-0'
                  }
                />
              </div>
            </div>
          </div>
        </div>
        {/*資産目標サポートの利用*/}
        <div className="lp-section-block">
          <div className="panel-plan-info">
            <div className="plan-header">
              <div className="plan-badge">資産目標サポートの利用</div>
              <ul className="plan-header-list">
                <li className="plan-header-list-item status-free">
                  <div className="plan-header-list-title">
                    利用
                    <br />
                    できません
                  </div>
                </li>
                <li className="plan-header-list-item status-premium">
                  <div className="plan-header-list-title">利用可能</div>
                </li>
              </ul>
            </div>
            <div className="plan-body">
              <div
                className={
                  advisorExpandable
                    ? 'plan-body-contents is-expanded ui-effect-fade-in-300 visible'
                    : 'plan-body-contents is-expanded ui-effect-fade-out-300 invisible'
                }
                style={{
                  maxHeight: advisorExpandable ? '' : '0px',
                  display: advisorExpandable ? '' : 'none',
                }}>
                <div className="plan-body-visual">
                  <img
                    src="/static/images/premiumLP/walk4.png"
                    alt=""
                    className="plan-body-visual-primary"
                  />
                  <img
                    src="/static/images/lp/aiadoviser.png"
                    alt=""
                    className="plan-body-visual-secondary"
                  />
                </div>
                <div className="plan-body-block">
                  <div className="plan-body-title">
                    ゴールに向けた具体的な提案
                  </div>
                  <div className="plan-body-note">
                    資産形成の目標に向けて、今のままで達成できるのか、見直しが必要なのかを提案します。
                  </div>
                </div>
              </div>
              <div
                className="plan-toggle-row cursor-pointer"
                id="advisor"
                onClick={onClickContent}>
                <div className="plan-toggle-label">
                  {advisorExpandable ? '閉じる' : 'どんな機能？'}
                </div>
                <Icon
                  className="text-2xl transition duration-300"
                  name={
                    advisorExpandable
                      ? 'chevron-down transform rotate-180'
                      : 'chevron-down transform rotate-0'
                  }
                />
              </div>
            </div>
          </div>
        </div>
        {/*みんかぶマガジン*/}
        <div className="lp-section-block">
          <div className="panel-plan-info">
            <div className="plan-header">
              <div className="plan-badge">みんかぶマガジン</div>
              <ul className="plan-header-list">
                <li className="plan-header-list-item status-free">
                  <div className="plan-header-list-title">
                    無料記事
                    <br />
                    のみ
                  </div>
                </li>
                <li className="plan-header-list-item status-premium">
                  <div className="plan-header-list-title">読み放題</div>
                </li>
              </ul>
            </div>
            <div className="plan-body">
              <div
                className={
                  magazineExpandable
                    ? 'plan-body-contents is-expanded ui-effect-fade-in-300 visible'
                    : 'plan-body-contents is-expanded ui-effect-fade-out-300 invisible'
                }
                style={{
                  maxHeight: magazineExpandable ? `` : '0px',
                  display: magazineExpandable ? '' : 'none',
                }}>
                <div className="plan-body-visual">
                  <img
                    src="/static/images/premiumLP/walk1.png"
                    alt=""
                    className="plan-body-visual-primary"
                  />
                  <img
                    src="/static/images/lp/magazin.png"
                    alt=""
                    className="plan-body-visual-secondary"
                  />
                </div>
                <div className="plan-body-block">
                  <div className="plan-body-title">お金のことを楽しく学ぶ</div>
                  <div className="plan-body-note">
                    お金のスペシャリストがお届けする資産形成のトレンド情報や、資産形成初心者が楽しく学べるコラムなど、役に立つ情報を配信します。一部、無料でお読みいただける記事もあります。
                  </div>
                </div>
              </div>
              <div
                className="plan-toggle-row cursor-pointer"
                id="magazine"
                onClick={onClickContent}>
                <div className="plan-toggle-label">
                  {magazineExpandable ? '閉じる' : 'どんな機能？'}
                </div>
                <Icon
                  className="text-2xl transition duration-300"
                  name={
                    magazineExpandable
                      ? 'chevron-down transform rotate-180'
                      : 'chevron-down transform rotate-0'
                  }
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PremiumLp;
